import { render } from "./DirectMember.vue?vue&type=template&id=28767c1a&scoped=true"
import script from "./DirectMember.vue?vue&type=script&lang=js"
export * from "./DirectMember.vue?vue&type=script&lang=js"

import "./DirectMember.vue?vue&type=style&index=0&id=28767c1a&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28767c1a"]])

export default __exports__